import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/img/Rectangle.jpg'


const _hoisted_1 = { class: "w-full p-[20px] flex justify-center items-center" }
const _hoisted_2 = { class: "w-full flex items-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center mr-[10px] md:mr-[20px]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "rounded-[50%] h-[30px] w-[30px] md:w-[50px] md:h-[50px]"
  })
], -1)
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "w-full flex justify-between items-center relative" }
const _hoisted_6 = { class: "w-[49%] md:my-[10px] my-[5px] mt-0 text-left" }
const _hoisted_7 = { class: "w-[49%] md:my-[10px] my-[5px] mt-0 text-left" }
const _hoisted_8 = { class: "flex justify-between items-center relative w-full" }
const _hoisted_9 = { class: "w-full md:my-[10px] my-[5px]" }
const _hoisted_10 = { class: "flex justify-between items-center relative w-full" }
const _hoisted_11 = { class: "w-full flex my-[5px] md:my-[20px] justify-end" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_14 = { key: 1 }

import axios from 'axios';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axiosInstance from '@/plugins/axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'commentComponent',
  setup(__props) {

const loading = ref(false);
const username = ref('');
const email = ref('');
const content = ref('');

const router = useRouter();

const errorMessage = ref("");

const postComment = async () => {
  const commentData = {
    username: username.value,
    email: email.value,
    content: content.value,
  };

  const articleId = router.currentRoute.value.params.id;

  try {
    loading.value = true
    const response = await axiosInstance.post(`/articles/${articleId}/comments/`, commentData);

    clearForm();
    window.location.reload();

  } catch (error) {
        errorMessage.value = 'Erreur !!! Votre commentaire n\'a pas été envoyé';
        hideErrorMessageAfterDelay();
  } finally {
    loading.value = false
  }
};

const clearForm = () => {
  username.value = '';
  email.value = '';
  content.value = '';
};

const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        class: "w-full",
        onSubmit: _withModifiers(postComment, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "username",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
              "aria-label": "username",
              placeholder: "Username or Name",
              class: "placeholder:text-blue-700 placeholder w-full p-[10px] border border-gray-400 rounded-[5px] outline-none focus:border-blue-500"
            }, null, 512), [
              [_vModelText, username.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
              placeholder: "Email",
              class: "placeholder:text-blue-700 placeholder w-full p-[10px] border border-gray-400 rounded-[5px] outline-none focus:border-blue-500"
            }, null, 512), [
              [_vModelText, email.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("textarea", {
              type: "text",
              id: "description",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((content).value = $event)),
              placeholder: "Add comment",
              class: "w-full h-[100px] md:h-[200px] resize-none p-[10px] border border-gray-400 rounded-[5px] outline-none focus:border-blue-500"
            }, null, 512), [
              [_vModelText, content.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "submit",
              disabled: loading.value,
              class: "bg-blue-700 text-white min-w-[70px] hover:bg-blue-800 hover:font-bold duration-300 rounded-[5px] px-[20px] py-[10px]"
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, "Post"))
            ], 8, _hoisted_12)
          ])
        ])
      ], 40, _hoisted_4)
    ])
  ]))
}
}

})